module.exports = __webpack_public_path__ + "4e6b462627f65677acfb8e9392d8591b.pdf";